module.exports = __webpack_public_path__ + "static/media/cartoes_selecao_disabled.c685f3db.svg";